// Module
var code = `<div class="slider-container">
    <div class="slider-control" >
        <input 
                style="background: linear-gradient(to right, var(--slider-fill-color) 0%, var(--slider-fill-color) {{backgroundInPercent}}%, var(--slider-empty-color) {{backgroundInPercent}}%, var(--slider-empty-color) 100%)"
                id="slider" type="range" value="{{rangeValue}}" min="{{min}}" max="{{max}}" step="{{step}}" on-input="onChangeValue" 
                on-change="onScroll" 
                on-mousewheel="onMouseWheel">
    </div>

    <div class="slider-scale">
    {{#each labelsWithLeft}}
        <div class="{{#if value <= rangeValue}}left-marker{{else}}right-marker{{/if}}{{#if value == rangeValue}} current-marker{{/if}}" 
            style="left: {{left}}%;">{{label}}</div>
    {{/each}}
    </div>
</div>`;
// Exports
export default code;